import { sizes, spacing } from '@gitbook/react-uikit';

export const BLOCKQUOTE_BORDER_WIDTH = 4;
export const BLOCKQUOTE_PADDING_LEFT = spacing.medium;

export const HINT_BORDER_WIDTH = 4;
export const HINT_PADDING_LEFT = spacing.xlarge + spacing.small;

export const TABS_ITEM_PADDING_LEFT = spacing.large;

export const LEFT_GUTTER_LIMIT = -96;
export const LEFT_LIMIT = LEFT_GUTTER_LIMIT + 24;

/**
 * Size of the diff icon.
 */
export const DIFF_ICON_SIZE = sizes.ICON_300;
/**
 * Default left value of the diff indicator.
 */
export const DIFF_LINE_LEFT_DEFAULT = LEFT_LIMIT;

/**
 * Default left values for list blocks
 */
export const DIFF_LINE_LEFT_UL = spacing.large + 4;
export const DIFF_LINE_LEFT_OL = spacing.large + 8;
export const DIFF_LINE_LEFT_LIST_TASKS = spacing.large + 8;

/**
 * Default left value for nested list blocks
 */
export const DIFF_LINE_LEFT_NESTED_UL = 28;
export const DIFF_LINE_LEFT_NESTED_OL = 32;
export const DIFF_LINE_LEFT_NESTED_LIST_TASKS = 34;

/**
 * Height of the lines between blocks.
 */
export const INSERTION_LINE_HEIGHT = spacing.small;
